// AI Generated Test
import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { PolicyFormHelperService } from '@client/app/blocks/helpers/policy-form-helper/policy-form.helper.service';
import { MonDialog } from '@client/app/modules/dialog-upgrade-wrapper/mon-dialog.service';
import { NgForm } from '@angular/forms';
import { FormUtils } from '@client/ng2/shared/form-utils';

import { safeClone } from '@client/app/shared/utils/object-utils';
@Component({
    selector: 'form-global-policy-dialog-rule-meta-header-length',
    templateUrl: './form-global-policy-dialog-rule-meta-header-length.component.html',
    standalone: false,
})
export class FormGlobalPolicyDialogRuleMetaHeaderLengthComponent implements OnInit, AfterViewInit {
    @Input() cRule: any;
    @Input() monDialogId: any;

    @ViewChild('policyRuleForm') policyRuleForm?: NgForm;

    typeOptions: any[] = [];
    dropdownOptions: any[] = [];
    selectedOption: any = {};
    subEntry: any = { options: [] };
    areAllSubEntriesSelected: boolean = false;

    constructor (
        private policyFormHelperService: PolicyFormHelperService,
        private monDialog: MonDialog,
    ) {}

    ngOnInit (): void {
        this.activate();
    }

    ngAfterViewInit () {
        this.monDialog.setFocus(this.monDialogId, this.policyRuleForm);
    }

    activate (): void {
        this.policyFormHelperService.setRuleType(this.cRule.type);
        this.setupTypeOptions();
        const parsed = parseInt(this.cRule.query);
        if (!isNaN(parsed)) {
            this.cRule.query = parsed;
        }
        if (!this.cRule.name) {
            this.chooseOperator(this.typeOptions.length > 0 ? this.typeOptions[0] : {});
        } else {
            this.chooseOperator(
                this.typeOptions.find((type: any) => {
                    return type.type === this.cRule.operator;
                }),
            );
        }
    }

    setupTypeOptions (): void {
        this.typeOptions = this.policyFormHelperService.getOptionsByRuleType();
        this.dropdownOptions = this.typeOptions.map(option => {
            return {
                ...option,
                action: () => this.chooseType(option),
                label: option.translation,
            };
        });
    }

    chooseOperator (option: any): void {
        this.selectedOption = option;
        this.cRule.operator = option.type;
    }

    chooseType (option: any): void {
        this.chooseOperator(option);
    }

    checkSelectedSubEntries (): void {
        this.areAllSubEntriesSelected =
            this.subEntry.options.length > 0 && this.subEntry.options.length === this.cRule.sub_entry.length;
    }

    close (): void {
        const newRule = safeClone(this.cRule);
        newRule.query = newRule.query === '' ? 0 : newRule.query;
        FormUtils.markFormAsPristine(this.policyRuleForm);
        this.monDialog.close(this.monDialogId, newRule);
    }
}
